function Loading() {
  return (
    <div className="loading">
      <div className="spinner"></div>
      <p>Chargement...</p>
    </div>
  )
}

export default Loading
